import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "text-center" };
const _hoisted_2 = { class: "d-inline-block p-2 mb-4 titulo" };
const _hoisted_3 = { class: "py-2 mb-3 contador" };
const _hoisted_4 = {
    ref: "color",
    class: "color_fondo",
    id: "fondo_color"
};
const _hoisted_5 = {
    ref: "numero",
    class: "numero",
    id: "numero"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.titulo), 1),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, null, 512),
            _createElementVNode("div", _hoisted_5, null, 512)
        ])
    ]));
}
